import React from 'react';
import moment from 'moment';
import { useAppSelector } from '../../redux/hooks';
import { bootstrapTimezoneSelector } from '../../redux/selectors/bootstrap';
import { globalFormat } from '../../utils/formatting';
import GeneralFormItem from '../GeneralFormItem';
import { Placement } from '@floating-ui/react';

interface IProps {
  date: string;
  placement?: Placement;
  disabled?: boolean;
}

const TableDateCell = ({ date, placement, disabled }: IProps) => {
  const syndicateTimezone = useAppSelector(bootstrapTimezoneSelector);
  const shortTz = moment().tz(syndicateTimezone).zoneAbbr();
  const { dateFormat, timeFormat } = globalFormat.getGlobalFormat();

  return (
    <GeneralFormItem
      label={`${globalFormat.formatDate(date, { dateFormat })}`}
      tooltipContent={`${globalFormat.formatDate(date, { dateFormat, timeFormat })} ${shortTz}`}
      placement={placement}
      isDisabled={disabled}
    />
  );
};

export default TableDateCell;
